import { Pipe, PipeTransform } from '@angular/core';
/*
 * Transforms a given time in seconds to a string with rounded time values according
 * to defined intervals
 *
 * Usage:
 *   durationInMinutes | duration
 * Example:
 *   {{ 70 | duration}}
 *   formats to: 1h 30m
*/
@Pipe({name: 'duration'})
export class DurationPipe implements PipeTransform {

  transform(durationInMinutes: string): string {
    let duration = parseInt(durationInMinutes)
    if (isNaN(duration)) {
      return ''
    }
    if (duration < 60) {
      return `${duration}m`
    }
    let hours = Math.floor(duration / 60)
    let minutes = (duration % 60)
    let result = `${hours}h`
    if (minutes > 0) {
      result += ` ${minutes}m`
    }
    return result
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/duration.pipe.ts